import Vue from "vue";
import Vuex from "vuex";
import workos from "@/store/workos";
import organization from "@/store/organization";
import registration from "@/store/registration";
import role from "@/store/role";
import feature from "@/store/feature";
import signedUrl from "@/utils/signedUrl";
import signin from "@/store/signin";
import statics from "@/store/static";
import user from "@/store/user";

Vue.use(Vuex);

// plugins
const init = store => {
  // Initialize auth modules sequentially to prevent race conditions
  (async () => {
    await store.dispatch("workos/initialize");
    await store.dispatch("user/initialize");
  })();
};

const mutations = store => {
  store.subscribe(mutation => {
    switch (mutation.type) {
      case "workos/setUser": // WorkOS uses setUser, not signIn
      case "workos/clearUser": // WorkOS uses clearUser, not signOut
        store.dispatch("user/initialize");
        break;
      case "user/setInitialized":
      case "user/setUser":
        store.dispatch("feature/initialize");
        store.dispatch("role/initialize");
        store.dispatch("organization/initialize");
        break;
    }
  });
};

const fullstory = store => {
  store.subscribe(mutation => {
    if (mutation.type === "user/setUser") {
      if (!mutation.payload) return;
      // reference: https://help.fullstory.com/hc/en-us/articles/360020623294-FS-setUserVars-Recording-custom-user-data
      Vue.prototype.$FullStory.identify(mutation.payload.id, {
        displayName: mutation.payload.fullName,
        email: mutation.payload.emailAddress,
      });
    }
    if (mutation.type === "organization/setOrganizations") {
      if (!mutation.payload) return;
      // reference: https://help.fullstory.com/hc/en-us/articles/360020623294-FS-setUserVars-Recording-custom-user-data
      Vue.prototype.$FullStory.setUserVars({
        OrganizationIds_strs: mutation.payload.map(o => o.id),
        OrganizationDisplayNames_strs: mutation.payload.map(o => o.displayName),
        OrganizationLegalNames_strs: mutation.payload.map(o => o.legalName),
      });
    }
    if (mutation.type === "workos/signOut") {
      // reference: https://developer.fullstory.com/anonymize
      Vue.prototype.$FullStory.anonymize();
    }
  });
};

export default new Vuex.Store({
  plugins: [init, mutations, fullstory],
  actions: {
    signOut: async ({ dispatch, getters }) => {
      const isWorkOs = getters["workos/isAuthenticated"];
      let redirectUrl = "/signin";

      // Sign out of WorkOS
      if (isWorkOs) {
        const res = await dispatch("workos/signOut", { redirect: false });
        if (res && res.redirect_url) {
          redirectUrl = res.redirect_url;
        }
      }

      return { success: true, redirect_url: redirectUrl };
    },
  },
  getters: {
    isInitialized(state) {
      const result =
        state.workos.isInitialized && state.user.isInitialized && state.role.isInitialized && state.feature.isInitialized && state.organization.isInitialized;
      return result;
    },
    isAuthenticated(_, getters) {
      var isWorkOS = getters["workos/isAuthenticated"];
      var isSignedUrl = signedUrl.isSignedUrl();
      return isWorkOS || isSignedUrl;
    },
    userId(_, getters) {
      var workosUserId = getters["workos/userId"];
      var signedUrlUserId = signedUrl.getUserId();
      return workosUserId || signedUrlUserId;
    },
  },
  modules: {
    workos,
    organization,
    registration,
    role,
    feature,
    signin,
    static: statics,
    user,
  },
});
